import { ExportType } from 'modules/audiences/AudienceProvider';

export const canSetExportTargets = (exportType: ExportType = ExportType.OA_MATCH): boolean =>
  !exportType || [ExportType.OA_MATCH, ExportType.BIDSTREAM_PLUS].includes(exportType); // if export_type is null we should treat it like a default method
